const API_BASE = process.env.REACT_APP_API_BASE || '';

export function getApiBase(): string {
  return API_BASE;
}

/** Headers for authenticated requests to backend-go (JWT from login/register). */
export function authHeaders(json = true): HeadersInit {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('auth-token') : null;
  const h: Record<string, string> = {};
  if (json) {
    h['Content-Type'] = 'application/json';
  }
  if (token) {
    h['Authorization'] = `Bearer ${token}`;
  }
  return h;
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;
  const headers = new Headers(init.headers);
  const auth = authHeaders(!headers.has('Content-Type'));
  Object.entries(auth).forEach(([k, v]) => {
    if (!headers.has(k)) headers.set(k, v);
  });
  return fetch(url, { ...init, headers, credentials: 'include' });
}

export async function safeJson<T>(res: Response): Promise<T | null> {
  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    return null;
  }
  try {
    return (await res.json()) as T;
  } catch {
    return null;
  }
}
